// PCA and coordinate utilities for Mapbox/PCA integration
// These are stubs to be implemented and tested incrementally

// Helper: convert [lng, lat] to approximate meters using equirectangular projection
function lngLatToMeters([lng, lat], origin) {
  // Approximate conversion (good enough for parcel-scale analysis)
  const R = 6378137; // Earth radius in meters
  const dLng = (lng - origin[0]) * Math.PI / 180;
  const dLat = (lat - origin[1]) * Math.PI / 180;
  const x = dLng * R * Math.cos(origin[1] * Math.PI / 180);
  const y = dLat * R;
  return [x, y];
}

// Calculate the principal orientation of a set of parcel vertices using PCA
export function calculatePrincipalOrientation(vertices) {
  if (!vertices || vertices.length < 2) return 0;
  // Use the centroid as the origin for projection
  const centroid = vertices.reduce((acc, [lng, lat]) => [acc[0] + lng, acc[1] + lat], [0, 0])
    .map(sum => sum / vertices.length);
  // Convert to meters
  const points = vertices.map(([lng, lat]) => lngLatToMeters([lng, lat], centroid));
  // Center the data
  const mean = points.reduce((acc, [x, y]) => [acc[0] + x, acc[1] + y], [0, 0])
    .map(sum => sum / points.length);
  const centered = points.map(([x, y]) => [x - mean[0], y - mean[1]]);
  // Compute covariance matrix
  let xx = 0, xy = 0, yy = 0;
  for (const [x, y] of centered) {
    xx += x * x;
    xy += x * y;
    yy += y * y;
  }
  xx /= centered.length;
  xy /= centered.length;
  yy /= centered.length;
  // Compute eigenvector for largest eigenvalue
  const theta = 0.5 * Math.atan2(2 * xy, xx - yy); // angle in radians
  const angleDeg = theta * 180 / Math.PI;
  return angleDeg;
}

// Test layout efficiency at various angles around the base angle
export function findOptimalRotation(vertices, baseAngle, boxWidth, boxLength, buildingPadding, layoutType) {
  // 1. Test angles at ±10° intervals around baseAngle
  // 2. For each angle, rotate the parcel and run layout algorithm
  // 3. Calculate efficiency (box count or area coverage)
  // 4. Return angle with highest efficiency
  return { angle: baseAngle, efficiency: 0 }; // TODO: implement
}

// Rotate an array of coordinates around a center point
export function rotateCoordinates(vertices, angle, center) {
  // Apply rotation matrix around center point
  return vertices; // TODO: implement
}

// Rotate a single point around a center point
export function rotatePoint(point, center, angle) {
  // Rotate single point around center
  return point; // TODO: implement
}
